import { useEffect } from 'react'

import { fetchListBanners } from 'actions/ContentActions'
import { BANNER_LOCATION_CRUISES } from 'constants/bannerLocations'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'

import Leaderboard from 'components/Common/Banner/Leaderboard'

function CruisePageBannersSection() {
  const dispatch = useAppDispatch()
  const banners = useAppSelector(state => state.content.listBanners.cruises)

  useEffect(() => {
    dispatch(fetchListBanners(BANNER_LOCATION_CRUISES))
  }, [dispatch])

  return <Leaderboard banners={banners ?? []} />
}

export default CruisePageBannersSection
